// @flow
import Number, {
  getDerivedStateFromPropsLogic,
} from '../../Core/Components/_formFields/Number'

import type {
  NumberProps,
  NumberState,
} from '../../Core/Components/_formFields/Number'

const MIN_CONVERT_CCM_THRESHOLD = 1.0
const MAX_CONVERT_CCM_THRESHOLD = 20.0

const CCM_MULTIPLIER = 1000

export default class EngineCapacity extends Number<NumberProps, NumberState> {
  static getDerivedStateFromProps (nextProps: NumberProps, prevState: NumberState) {
    return getDerivedStateFromPropsLogic(nextProps, prevState)
  }

  constructor (props: NumberProps) {
    super(props)
  }

  formatValue = (actualValue: string): number => {
    return parseFloat(actualValue.replace(/\s/g, '').replace(',', '.'))
  }

  getUpdatedValue = (value: number): number => {
    if (value > MIN_CONVERT_CCM_THRESHOLD && value < MAX_CONVERT_CCM_THRESHOLD) {
      return value * CCM_MULTIPLIER
    }

    return value
  }

  handleOnChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    if (this.isPositiveFloatLikeString(event.target.value)) {
      this.setState({
        value: event.target.value,
      })
    }
  }

  isPositiveFloatLikeString = (value: string): Array<string> => {
    return value.match(/^(\d|\s)*,?\d{0,2}$/g) || value.match(/^(\d|\s)*\.?\d{0,2}$/g)
  }
}
